'use strict';

const NOTIFICATION_STATUSES = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
};
const NOTIFICATION_TIMEOUT = 15000;

exports.NOTIFICATION_STATUSES = NOTIFICATION_STATUSES;
exports.NOTIFICATION_TIMEOUT = NOTIFICATION_TIMEOUT;
//# sourceMappingURL=Notifications.types.js.map
